// import { createContextualCan } from "@casl/react";
// import React from "react";

// export const AbilityContext = React.createContext();
// export const Can = createContextualCan(AbilityContext.Consumer);

import React from "react";

// Define a basic Ability class
export class Ability {
  constructor(rules = []) {
    this.rules = rules;
  }

  can(action, subject) {
    return this.rules.some((rule) => {
      const matchAction = rule.action === action || rule.action === "manage";
      const matchSubject = rule.subject === subject || rule.subject === "all";
      //   const matchesField =
      //     !rule.field ||
      //     !fieldOrConditions ||
      //     rule.field === fieldOrConditions ||
      //     (Array.isArray(rule.field) && rule.field.includes(fieldOrConditions));

      return matchAction && matchSubject;
    });
  }

  // Optional: define 'cannot' for readability
  cannot(action, subject) {
    return !this.can(action, subject);
  }
}

// AbilityContext for React
export const AbilityContext = React.createContext();

// Custom Can component (replaces `createContextualCan`)
export const Can = ({ I, a, children, not = false }) => (
  <AbilityContext.Consumer>
    {(ability) => {
      const isAllowed = ability?.can(I, a);
      if ((isAllowed && !not) || (!isAllowed && not)) {
        return typeof children === "function" ? children() : children;
      }
      return null;
    }}
  </AbilityContext.Consumer>
);
